import Phaser from "phaser";
import { COLORS, GAME_HEIGHT, GAME_WIDTH } from "./config";
import BootScene from "./scenes/BootScene";
import MenuScene from "./scenes/MenuScene";
import GameScene from "./scenes/GameScene";
import BreathingScene from "./scenes/BreathingScene";
import LevelCompleteScene from "./scenes/LevelCompleteScene";

new Phaser.Game({
  type: Phaser.AUTO,
  parent: "game",
  backgroundColor: COLORS.bgTop,
  // Portrait, one-thumb. FIT scales the fixed design canvas to any screen.
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
  },
  physics: {
    default: "arcade",
    arcade: {
      debug: false,
    },
  },
  render: {
    antialias: true,
    roundPixels: false,
  },
  scene: [BootScene, MenuScene, GameScene, BreathingScene, LevelCompleteScene],
});
